import React from 'react';
import { Outlet } from 'react-router-dom';

function SurveyPeopleContainer() {
  return <Outlet />;
}

export default SurveyPeopleContainer;
